import React, { useEffect } from "react";
import CommonSideNavbar from "../common/CommonSideNavbar";
import {
  agencyDashboard,
  agencyProfile,
  activeLinkDashboard,
} from "../common/allLinks";
import ProfileDetails from "../common/ProfileDetails";
import BreadcrumbMenu from "../common/BreadcrumbMenu";

export default function AgencyDashboardClientProfile() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={agencyDashboard}
        profileLink={agencyProfile}
        activeLink={activeLinkDashboard}
      />
      <div className="sidenavbar-active-menu-page">
        <div className="mt-title-block">
          <BreadcrumbMenu
            menuObj={[
              {
                title: "Dashboard",
                link: agencyDashboard,
              },
              {
                title: "Requirement Name",
                type: "goBackButton",
              },
              {
                title: "Client Name",
              },
            ]}
          />
          <h1 className="mt-dashboard-title">Client Profile</h1>
        </div>
        <ProfileDetails />
      </div>
    </div>
  );
}
